/**
 * 最近 10 次供应商测试的记录（只在本页内存中，刷新页面后清空，与旧版一致）
 */
import { Button, Card, Tag, Timeline, Typography } from 'antd'
import type { TestHistoryItem } from './types'
import styles from './AIProviderPage.module.css'

const PREVIEW_LENGTH = 100

function preview(text: string) {
  return text.length > PREVIEW_LENGTH ? `${text.substring(0, PREVIEW_LENGTH)}...` : text
}

function HistoryEntry({ item }: Readonly<{ item: TestHistoryItem }>) {
  return (
    <div>
      <div className={styles.historyHeader}>
        <strong>{item.provider_name}</strong>
        <Typography.Text type="secondary" className={styles.small}>
          {item.model_name}
        </Typography.Text>
        <Tag color={item.success ? 'success' : 'error'}>{item.success ? '成功' : '失败'}</Tag>
        <Typography.Text type="secondary" className={`${styles.small} ${styles.historyTime}`}>
          {item.test_time}
        </Typography.Text>
      </div>
      <div className={styles.historyContent}>
        <div className={styles.historyMetrics}>
          {item.ttfb ? <Tag color="blue">首字: {item.ttfb.toFixed(3)}s</Tag> : null}
          <Tag color="blue">总时间: {item.response_time.toFixed(2)}s</Tag>
          {item.total_chars ? <Tag color="blue">字符: {item.total_chars}</Tag> : null}
          {item.chars_per_sec ? <Tag color="blue">速度: {item.chars_per_sec.toFixed(1)}字/秒</Tag> : null}
        </div>
        {item.success ? (
          item.message && <div className={styles.historyMessage}>{preview(item.message)}</div>
        ) : (
          <div className={styles.historyError}>错误: {preview(item.message)}</div>
        )}
      </div>
    </div>
  )
}

export function TestHistoryCard({ history, onClear }: Readonly<{ history: TestHistoryItem[]; onClear: () => void }>) {
  if (history.length === 0) return null
  return (
    <Card
      title="测试历史记录"
      className={styles.historyCard}
      extra={
        <Button size="small" onClick={onClear}>
          清空历史
        </Button>
      }
    >
      <Timeline
        items={history.map((item) => ({
          key: item.id,
          color: item.success ? 'green' : 'red',
          content: <HistoryEntry item={item} />
        }))}
      />
    </Card>
  )
}
